export default __webpack_public_path__ + "static/media/ovo_m.c80ab396.jpg";